import { useState } from "react";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid"
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import ButtonBase from '@mui/material/ButtonBase';

import { grey } from '@mui/material/colors';
import { Checkbox, Divider, Drawer, MenuItem, Select } from "@mui/material";

import CloseIcon from '@mui/icons-material/Close';

// 送信先選択パート
function SelectDestinationSendingGroupPart({
  shops,
  setShops,
  customerSendingGroupInfoList
}) {

const [selectingCustomerSendingGroupIdValue, setSelectingCustomerSendingGroupIdValue] = useState("-1");

const getCustomerSendingGroupList = () => {
  let customerSendingGroupList = [];
  let lastGroupId = -1;

  customerSendingGroupInfoList.forEach((data)=> {
    if (lastGroupId !== data.customerSendingGroupId) {
      customerSendingGroupList.push({
        customerSendingGroupId: data.customerSendingGroupId,
        customerSendingGroupName: data.customerSendingGroupName    
      })
    }

    lastGroupId = data.customerSendingGroupId      
  });

  return customerSendingGroupList;
}

const getGroupMemberShops = (groupId) => {
  if (!groupId) {
    return [];
  }

  return customerSendingGroupInfoList
    .filter((data) => (data.customerSendingGroupId === groupId))
    .map((data) => ({
      ...data,
      is_selected: true
    }));
}

const handleChangeSelectingGroup = (event) => {
  setSelectingCustomerSendingGroupIdValue(event.target.value);
  setShops(getGroupMemberShops(parseInt(event.target.value)));
}

const handleChangeSelectingShop = (index) => (event) => {
  let newMemberShops = [...shops];
  newMemberShops[index].is_selected = event.target.checked;
  setShops(newMemberShops);    
}

return (
    <Box>
      <Typography>取引先送信グループ選択</Typography>

      <Box marginBottom={1}>
        <Select
          value={selectingCustomerSendingGroupIdValue}
          onChange={handleChangeSelectingGroup}
          sx={{minWidth: 200}}
        >
          <MenuItem key="group_unselected" value="-1">[未選択]</MenuItem>
          {
            getCustomerSendingGroupList().map((groupData, i) => {
              return (
                <MenuItem key={`group_${i}`} value={groupData.customerSendingGroupId.toString()}>
                  {groupData.customerSendingGroupName}
                </MenuItem>
              );
            })                
          } 
        </Select>
      </Box>
      <Typography>送信対象店舗選択</Typography>
      <Box border="1px black solid" height="50vh" sx={{overflowY: "auto"}}>
        <TableContainer component={Paper} >
          <Table>
            <TableBody>
              {
                shops.map((shopData, i) => (
                  <TableRow key={`shop_${i}`}>
                    <TableCell padding="none" sx={{width:0}}>
                      <Checkbox
                        checked={shopData.is_selected}
                        onChange={handleChangeSelectingShop(i)}                        
                      />
                    </TableCell>
                    <TableCell padding="none" sx={{width:"60%"}}>
                      <Typography>{shopData.customerName}</Typography>
                    </TableCell>
                    <TableCell padding="none">
                      <Typography>{shopData.shopName}</Typography>
                    </TableCell>                      
                  </TableRow>
                ))
              }
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
  </Box>
)
}

export function SelectDestinationSendingGroupDrawer ({open, dialogOpen, onClose, params}) {

  return (
    <Drawer
      open={open}
      onClose={onClose}
      variant="persistent"
      anchor="right"
      PaperProps={{
        style: {
          position: "absolute"
        }
      }}
    >
      <Box padding={2} width="30vw">
        <ButtonBase onClick={onClose}>
          <Grid container>
            <Grid item xs="auto">
              <CloseIcon htmlColor={grey[600]} />
            </Grid>
            <Grid item  xs="auto">
              <Typography>閉じる</Typography>
            </Grid>              
          </Grid>            
        </ButtonBase>

        <Divider sx={{marginY: 1}}/>      

        <Box marginBottom={2}>
          <SelectDestinationSendingGroupPart
            shops={params.shops}
            setShops={params.setShops}
            customerSendingGroupInfoList={params.customerSendingGroupInfoList}
          />
        </Box>
      </Box>
    </Drawer>
  )
}

